import { useContext, useEffect } from 'react';
import useUrlSlug from '../../Settings/Advanced/AppsManager/CreateAppForm/useUrlSlug';
import { V3AppsContext } from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/V3AppsProvider';

/**
 * Used in forms where we don't want the user to have to explicitly set
 * a URL slug
 */
const useGetWorkspaceUrlSlugForName = (name: string) => {
  const { reservedWorkspaceUrlSlugs } = useContext(V3AppsContext);
  const { urlSlug, setUrlSlug, getIsUrlSlugValid, isUrlSlugValid } = useUrlSlug(
    undefined,
    reservedWorkspaceUrlSlugs,
  );

  useEffect(() => {
    if (name === '') {
      setUrlSlug('');
      return;
    }

    const baseSlug = encodeURI(name.toLowerCase().replaceAll(' ', '-'));
    let currentSlug = encodeURI(name.toLowerCase().replaceAll(' ', '-'));
    let hasFoundValidSlug = false;

    for (let i = 1; i < 256 && !hasFoundValidSlug; i++) {
      if (getIsUrlSlugValid(currentSlug)) {
        setUrlSlug(currentSlug);
        hasFoundValidSlug = true;
      }
      currentSlug = `${baseSlug}-${i}`;
    }
  }, [getIsUrlSlugValid, name, setUrlSlug]);

  return {
    urlSlug: name === '' ? undefined : urlSlug,
    isUrlSlugValid,
  };
};

export default useGetWorkspaceUrlSlugForName;
